import {
  Avatar,
  Box,
  Card,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { getClientByCnpj } from "../services/clientService";
import { useEffect, useState } from "react";
import { DeleteDialog } from "./DeleteDialog";

interface UserCardProps {
  userId: any;
  user: any;
  permission: string;
  onRemove: () => void;
}

const UserCard: React.FC<UserCardProps> = ({
  user,
  userId,
  permission,
  onRemove,
}) => {
  const [client, setClient] = useState<any>();
  const [confirmationModal, setConfirmationModal] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const fetchClientInfo = async (cnpj: string) => {
    try {
      if (cnpj === "05.533.354/0001-15") {
        setClient({
          NOME: "BRAXCOM SERVICOS ADUANEIROS E CONSULTORIA TECNICA LTDA",
        });
      } else {
        const data = await getClientByCnpj(cnpj);
        setClient(data);
      }
    } catch (err) {
      console.error("Erro ao buscar empresa associada:", err);
    }
  };

  useEffect(() => {
    const cnpj = user["custom:cnpj"] || "05.533.354/0001-15";
    fetchClientInfo(cnpj);
  }, []);

  const [firstName = "", lastName = ""] = user.name?.trim()?.split(" ") ?? [];

  return (
    <>
      <Card
        elevation={0}
        sx={{
          display: "flex",
          alignItems: "flex-start",
          bgcolor: "#F8F9FA",
          borderRadius: "12px",
          position: "relative",
          overflow: "hidden",
          width: "100%",
          height: isMobile ? "auto" : "132px",
        }}
      >
        <Box
          sx={{
            width: "24px",
            height: "100%",
            bgcolor: "#90EE90",
            position: "absolute",
            left: 0,
            top: 0,
            bottom: 0,
          }}
        />

        <Box
          sx={{
            display: "flex",
            width: "100%",
            ml: 5,
            gap: 1,
            alignItems: "center",
          }}
        >
          <Avatar
            src={user.picture || undefined}
            sx={{
              width: 80,
              height: 80,
              mr: 1,
              mt: 2,
              backgroundColor: user.picture ? "transparent" : "#326AFD",
              color: user.picture ? "inherit" : "#FFFFFF",
              fontWeight: user.picture ? "normal" : "bold",
              fontSize: "1.8rem",
            }}
          >
            {!user.picture && `${firstName[0] || ""}${lastName[0] || ""}`}
          </Avatar>

          <Box sx={{ flex: 1 }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
                mt: 1,
              }}
            >
              <Typography style={{ fontSize: isMobile ? "18px" : "20px" }}>
                {user.name.split(" ")[0]}{" "}
                <strong>{user.name.split(" ").slice(1).join(" ")}</strong>
              </Typography>

              <div style={{ display: "flex", gap: 1 }}>
                <IconButton
                  size="small"
                  sx={{ color: "#0A0C33" }}
                  onClick={() => setConfirmationModal(true)}
                >
                  <DeleteIcon />
                </IconButton>
              </div>
            </Box>

            <Typography sx={{ color: "text.secondary", textAlign: "left" }}>
              Matrícula: #{userId + 1}
            </Typography>

            <Typography sx={{ color: "text.secondary", textAlign: "left" }}>
              Permissões: {permission}
            </Typography>

            <Typography sx={{ color: "text.secondary", textAlign: "left" }}>
              Associado:{" "}
              {client?.NOME?.split(" ").slice(0, 2).join(" ") ??
                "BRAXCOM SERVICOS"}
            </Typography>
          </Box>
        </Box>
      </Card>
      <DeleteDialog
        open={confirmationModal}
        onClose={() => setConfirmationModal(false)}
        onDelete={onRemove}
        userName={`${user.name.split(" ")[0]} ${user.name
          .split(" ")
          .slice(1)
          .join(" ")}`}
      />
    </>
  );
};

export default UserCard;
